// extracted by mini-css-extract-plugin
export var markdown = "column-module--markdown--1TAcX";
export var miller = "column-module--miller--Z8JEA";
export var tradeGothic = "column-module--tradeGothic--3EIuH";
export var curaleaf = "column-module--curaleaf--WnXnm";
export var usingMouse = "column-module--using-mouse--wmJ8Y";
export var selectMarkdown = "column-module--select-markdown--Ll1Bb";
export var select = "column-module--select--z_HgD";
export var imageContainer = "column-module--image-container--3zSA4";
export var textColumnContainer = "column-module--text-column-container---8WL5";
export var rightColumnFourtySixtyTextContainer = "column-module--right-column-fourty-sixty-text-container--sWKXu";
export var leftColumnFourtySixtyTextContainer = "column-module--left-column-fourty-sixty-text-container--1OIbG";
export var rightColumnSixtyFourtyTextContainer = "column-module--right-column-sixty-fourty-text-container--2dnBL";
export var leftColumnSixtyFourtyTextContainer = "column-module--left-column-sixty-fourty-text-container--1Ovj6";
export var halfRightColumn = "column-module--half-right-column--3Hl1_";
export var halfLeftColumn = "column-module--half-left-column--2y9B3";
export var sixtyFourty = "column-module--sixty-fourty--3GdW3";
export var leftAlign = "column-module--left-align--1XOFG";
export var centerAlign = "column-module--center-align--3qWNc";
export var rightAlign = "column-module--right-align--Kv9sg";
export var leftImagePadding = "column-module--left-image-padding--17yBs";
export var rightImagePadding = "column-module--right-image-padding--2g5qw";
export var fourtySixty = "column-module--fourty-sixty--1DoaT";
export var gatsbyImg = "column-module--gatsby-img--3Zk9G";
export var button = "column-module--button--uDYx0";